const HOME_GROUP_STORAGE_PREFIX = "df-home-project-group:v1";
const HOME_GROUP_EVENT = "df-home-project-group-changed";

export const MY_PROJECTS_GROUP_ID = "my-projects";

export function folderGroupId(folderId: string): string {
  return `folder:${folderId}`;
}

export function getSelectionStorageKey(organizationId: string | null): string {
  return `${HOME_GROUP_STORAGE_PREFIX}:${organizationId ?? "none"}`;
}

export function loadSelectedGroup(organizationId: string | null): string {
  const key = getSelectionStorageKey(organizationId);
  try {
    const value = localStorage.getItem(key);
    return value || MY_PROJECTS_GROUP_ID;
  } catch {
    return MY_PROJECTS_GROUP_ID;
  }
}

export function saveSelectedGroup(organizationId: string | null, groupId: string) {
  const key = getSelectionStorageKey(organizationId);
  localStorage.setItem(key, groupId);
}

export function emitSelectedGroupChanged(groupId: string) {
  window.dispatchEvent(new CustomEvent(HOME_GROUP_EVENT, { detail: { groupId } }));
}

export function onSelectedGroupChanged(listener: (groupId: string) => void) {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<{ groupId?: string }>;
    const groupId = customEvent.detail?.groupId;
    if (groupId) {
      listener(groupId);
    }
  };
  window.addEventListener(HOME_GROUP_EVENT, handler);
  return () => window.removeEventListener(HOME_GROUP_EVENT, handler);
}
